import {Box} from '@mui/material';

import {scorePill} from '../../../../../layouts/theme/designSystem';
import type {ProfileComparisonDeltaVariant} from '../../types/ProfileComparisonTypes';
import {getProfileComparisonDeltaVariant} from '../../utils/ProfileComparison/getProfileComparisonDeltaVariant';

export interface Props {
  delta: number | null;
}

const deltaChipStyles: Record<ProfileComparisonDeltaVariant, {bgcolor: string; color: string}> = {
  up: {bgcolor: scorePill.high.bgcolor, color: scorePill.high.color},
  down: {bgcolor: scorePill.low.bgcolor, color: scorePill.low.color},
  flat: {bgcolor: 'action.hover', color: 'text.secondary'},
};

const formatDeltaLabel = (delta: number | null, variant: ProfileComparisonDeltaVariant | null): string => {
  if (variant === null || delta === null) {
    return '—';
  }

  if (variant === 'flat') {
    return '—';
  }

  return delta > 0 ? `+${delta}` : `${delta}`;
};

export const ProfileComparisonResultDeltaChip = ({delta}: Props) => {
  const variant = getProfileComparisonDeltaVariant(delta);
  const label = formatDeltaLabel(delta, variant);
  const styles = variant ? deltaChipStyles[variant] : deltaChipStyles.flat;

  return (
    <Box
      component='span'
      sx={{
        fontSize: '11px',
        fontWeight: 600,
        px: 0.75,
        py: 0.25,
        borderRadius: '99px',
        minWidth: 36,
        textAlign: 'center',
        ...styles,
      }}
    >
      {label}
    </Box>
  );
};
